/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
function plural(val) {
  const n = val;
  if (n === 1) return 1;
  return 5;
}
export default ["om-KE", [["WD", "WB"], u, u], u, [["D", "W", "Q", "R", "K", "J", "S"], ["Dil", "Wix", "Qib", "Rob", "Kam", "Jim", "San"], ["Dilbata", "Wiixata", "Qibxata", "Roobii", "Kamiisa", "Jimaata", "Sanbata"], ["Dil", "Wix", "Qib", "Rob", "Kam", "Jim", "San"]], u, [["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"], ["Ama", "Gur", "Bit", "Elb", "Cam", "Wax", "Ado", "Hag", "Ful", "Onk", "Sad", "Mud"], ["Amajjii", "Guraandhala", "Bitooteessa", "Elba", "Caamsa", "Waxabajjii", "Adooleessa", "Hagayya", "Fuulbana", "Onkololeessa", "Sadaasa", "Muddee"]], [["A", "G", "B", "E", "C", "W", "A", "H", "F", "O", "S", "M"], ["Ama", "Gur", "Bit", "Elb", "Cam", "Wax", "Ado", "Hag", "Ful", "Onk", "Sad", "Mud"], ["Amajjii", "Guraandhala", "Bitooteessa", "Elba", "Caamsa", "Waxabajjii", "Adooleessa", "Hagayya", "Fuulbana", "Onkololeessa", "Sadaasa", "Muddee"]], [["KD", "CE"], u, ["Dheengadda Jeesu", "CE"]], 0, [6, 0], ["dd/MM/yy", "dd-MMM-y", "dd MMMM y", "EEEE, MMMM d, y"], ["HH:mm", "HH:mm:ss", "HH:mm:ss z", "HH:mm:ss zzzz"], ["{1} {0}", u, u, u], [".", ",", ";", "%", "+", "-", "E", "×", "‰", "∞", "NaN", ":"], ["#,##0.###", "#,##0%", "¤#,##0.00", "#E0"], "KES", "Ksh", "KES", {
  "ETB": ["Br"],
  "JPY": ["JP¥", "¥"],
  "KES": ["Ksh"],
  "USD": ["US$", "$"]
}, "ltr", plural];
